import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { TABLE_HEADER_BG_COLOR } from '@insurancemenu/imenu-components-lib/dist/components/tables/utils/constants';

const styles = {
  modal: { maxWidth: '100rem' },
  modalTitle: {
    marginBottom: '1.5rem',
  },
  groupName: {
    maxWidth: '100%',
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
  },
  modalFooter: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '4rem',
  },
  // Table Styles
  tableWrapper: {
    border: `1px solid ${colors.neutral[400]}`,
    borderRadius: '1rem',
    overflow: 'hidden',
    marginBottom: '4rem',
  },
  tableHeader: {
    boxSizing: 'border-box',
  },
  tableHeading: {
    padding: '1.6rem 1rem',
    backgroundColor: TABLE_HEADER_BG_COLOR,
    width: '15rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    '&:nth-child(2)': {
      width: '20rem',
    },
    '&:nth-child(3)': {
      width: '30rem',
    },
  },
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    padding: '1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
    },
    width: '15rem',
    '&:nth-child(2)': {
      width: '20rem',
    },
    '&:nth-child(3)': {
      width: '30rem',
    },
  },

  textBtn: {
    textTransform: 'uppercase',
    fontSize: '1.4rem',
  },
  actionsBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    '& button:first-child': {
      marginRight: '2rem',
    },
  },
  email: {
    fontSize: '1.6rem',
    margin: '0.5rem 0',
    display: 'grid',
    fontWeight: 700,
    gridTemplateColumns: '8rem 1fr',
    alignItems: 'center',
    '& span:first-child': {
      marginRight: '1rem',
    },
  },
  status_NEW: {
    color: colors.blue[600],
  },
  status_SENT: {
    color: colors.yellow[600],
  },
  status_BOUNCED: {
    color: colors.red[600],
  },
  status_FAILED_TO_SEND: {
    color: colors.orange[600],
  },
  status_OPENED: {
    color: colors.green[600],
  },
  status_BLOCK: {
    color: colors.red[600],
  },
  status_INVALID: {
    color: colors.red[600],
  },
  status_SPAM: {
    color: colors.red[600],
  },
  warningWrapper: {
    color: colors.neutral[900],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  missingExhibits: {
    paddingLeft: '0.5rem',
  },
  warningsBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginTop: '2rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
